<script>
import DuplicateTable from '@/components/document-validation/documentDetails/DuplicateTable.vue'
export default {
  components: {
    DuplicateTable
  },
  props: {
    item: {
      type: Object
    },
    content: {
      type: Object
    },
    canDelete: {
      type: Boolean
    }
  },
  data() {
    return {
      selectedDuplicates: [],
      duplicatesDeleting: false
    }
  },
  methods: {
    async deleteDuplicates() {
      this.duplicatesDeleting = true

      await this.$uploadService
        .confirmWarnings({
          OrderId: this.item.orderId,
          DocumentIds: [this.item.documentId],
          PostageOnCover: false,
          ConfirmProductionArea: false,
          ConfirmFontWarnings: false,
          DeleteDuplicates: true
        })
        .then(() => {
          this.$emit('deleted')
        })
        .catch(() => {})
        .finally(() => {
          this.duplicatesDeleting = false
        })
    }
  }
}
</script>
<template>
  <v-expansion-panel
    v-if="item.duplicates != undefined && item.duplicates.length > 0"
    id="duplicates"
  >
    <v-dialog :value="duplicatesDeleting" max-width="500" persistent>
      <v-card>
        <DialogBaseColoredTitle>{{
          $t(
            'component.documentValidation.documentDetailsDuplicates.delete.header'
          )
        }}</DialogBaseColoredTitle>
        <v-divider></v-divider>
        <DialogBaseText class="text-center"
          ><span class="d-block pb-6">{{
            $t(
              'component.documentValidation.documentDetailsDuplicates.delete.text'
            )
          }}</span>
          <v-progress-circular color="primary" indeterminate />
        </DialogBaseText>
      </v-card>
    </v-dialog>
    <v-expansion-panel-header disable-icon-rotate>
      {{
        $t('component.documentValidation.documentDetailsDuplicates.duplicates')
      }}
      <template #actions>
        <v-icon color="error"> mdi-alert-circle </v-icon>
      </template>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <DuplicateTable :duplicates="item.duplicates" />
      <v-list>
        <v-list-item-action v-if="canDelete" class="mb-0">
          <v-tooltip top>
            <template #activator="{ on, attrs }">
              <v-btn
                id="deleteDuplicatesBtn"
                v-bind="attrs"
                :loading="duplicatesDeleting"
                :disabled="!canDelete"
                color="error"
                v-on="on"
                @click="deleteDuplicates"
              >
                <v-icon dark>mdi-delete-forever</v-icon>
                {{ $t('button.delete') }}
              </v-btn>
            </template>
            <span>{{ $t('text.delete.duplicates') }}</span>
          </v-tooltip>
        </v-list-item-action>
      </v-list>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>
<style lang="scss" scoped>
.overlap {
  overflow: hidden;
  text-overflow: ellipsis;
}
.v-list-item {
  min-height: 28px;
}
.v-list-item__content {
  padding: 0 !important;
}
</style>
